module.exports = __webpack_public_path__ + "img/onlyIcon-noBG.51cdfb89.png";